import { isDate, isUndefined } from 'lodash-es';

import { DateString } from '../types/dates.js';

/** Detects if a string is accepted by Date javascript type */
export const isDateString = (dateString: unknown): dateString is DateString => {
  if (typeof dateString !== 'string') {
    return false;
  }

  return isValidTimestamp(dateString);
};

/** Validates if an input number or string is a valid timestamp */
export const isValidTimestamp = (timestamp: number | string): boolean =>
  !isNaN(new Date(timestamp).getTime());

/** Checks if an input is valid to be used as a timestamp. */
export const isDateCompatibleToTimestamp = (
  input: number | DateString | Date | undefined,
): input is number | DateString | Date =>
  !isUndefined(input) &&
  (isDateString(input) || isDate(input) || isValidTimestamp(input));

/** Check if an unknown value could be parsed to a date */
export const isParseableDate = (value: unknown) => {
  if (value instanceof Date) {
    return true;
  }
  if (typeof value === 'number') {
    return false;
  } else if (typeof value === 'string') {
    if (value.trim() === '') {
      return false;
    }
    if (!isNaN(Number(value))) {
      return !!new Date(Number(value)).getTime();
    } else {
      return !!new Date(value).getTime();
    }
  }
  return false;
};
